import React, { useState } from "react";
import Button from "../Button/Button";
import { Table } from "../Table/Table";
import { FirstFilesWrapper } from "./FirstFilesStyle";
import { AiOutlineInteraction } from "react-icons/ai";
import { FaTrash } from "react-icons/fa";
import { ChangeResponsibleFirstFileModal } from "../Dialog/ChangeResponsibleFirstFileModal";
import { useGetFirstFiles } from "../../hooks/useCrm";
import Loading from "../Loadings/LoadingTable";
import { DeleteUserModal } from "../Dialog/DeleteUserModal";
import { useRecoilState } from "recoil";
import { crmshowAtom } from "../../shared/crm-show";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
export const FirstFiles = () => {
  const [Search, setSearch] = useState("");
  const [show, setShow] = useState({
    details: false,
    delete: false,
  });
  const { data, isLoading } = useGetFirstFiles();
  const [idActivity, setIdActivity] = useState();
  const [recoilShow, setRecoilShow] = useRecoilState(crmshowAtom);
  const headerTitle = [
    "ردیف",
    "نام و نام خانوادگی",
    "شماره تماس",
    "نام و نام خانوادگی مسئول",
    "استان-شهر",
    "منطقه",
    "نوع مشتری",
    "نوع فروش",
    "نحوه آشنایی",
    "رتبه بندی مشتری",
    "احتمال خرید",
    "تاریخ ثبت نام",
    "دسته بندی محصولات",
    "برند",
    "عملیات",
  ];
  const justNumberHeaderTitle = [
    "ردیف",
    "نام و نام خانوادگی",
    "شماره",
    "تاریخ",
    "عملیات",
  ];
  const justNumber = data?.data?.NotApproved?.filter((user) => {
    if (Search === "") {
      return user;
    } else if (user.FirstName.includes(Search)) {
      return user;
    } else if (user.LastName.includes(Search)) {
      return user;
    }
  }).map((item, index) => {
    return (
      <tr key={index}>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {index + 1}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {(item.FirstName ? item.FirstName : "") +
              " " +
              (item.LastName ? item.LastName : "")}
          </span>
        </td>

        <td>
          <span
            className="text-muted fw-bold text-muted d-block fs-7"
            onClick={() => {
              setRecoilShow(true);
              navigator.clipboard.writeText(item.Phone);
            }}
          >
            {item.Phone}
          </span>
        </td>
        <td>
          <span className="text-muted fw-bold text-muted d-block fs-7">
            {MiladiToShamsi(item.created_at)}
          </span>
        </td>
        <td>
          <div className="d-flex justify-content-start">
            <Button
              bgColor="#f1416c"
              color="#fff"
              small="fit-content"
              onclick={() => {
                setShow({ ...show, delete: true });
                setIdActivity(item.IdUser);
              }}
            >
              <FaTrash color={"#fff"} />
            </Button>
          </div>
        </td>
      </tr>
    );
  });
  const items = data?.data?.sales_opportunities
    ?.filter((user) => {
      if (Search === "") {
        return user;
      } else if (user.FirstName.includes(Search)) {
        return user;
      } else if (user.LastName.includes(Search)) {
        return user;
      }
    })
    .map((item, index) => {
      return (
        <tr key={index}>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {index + 1}
            </span>
          </td>
          <td>
            {/* <Link to={`/dashboard/crm/customer-file/${item.IdUser}`}> */}
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {(item.FirstName ?? "بدون نام") +
                " " +
                (item.LastName ? item.LastName : "")}
            </span>
            {/* </Link> */}
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item?.Phone}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              بدون مسئول
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.NameCities}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.Area == 0 ? "ندارد" : item.Area}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.KindCustomer}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.KindSeller}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.methodOfIntroduction}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.RankingCustomer}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.ProbabilityOfPurchase}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {MiladiToShamsi(item?.created_at)}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.NameCategory}
            </span>
          </td>
          <td>
            <span className="text-muted fw-bold text-muted d-block fs-7">
              {item.BrandCategory}
            </span>
          </td>
          <td>
            <Button
              bgColor="#f1416c"
              color="#fff"
              small="fit-content"
              onclick={() => {
                setShow({ ...show, details: true });
                setIdActivity(item.IdS0alesOpportunities);
              }}
            >
              <AiOutlineInteraction color={"#fff"} />
            </Button>
          </td>
        </tr>
      );
    });
  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <FirstFilesWrapper className="mt-3">
          <BreadCrumb
            margin="mt-3"
            num1="واحد CRM"
            num2="گزارشگیری"
            num3="ثبت نامی های سایت"
            href1="/dashboard/crm"
            href2="/dashboard/crm/reporting"
          />
          <Table
            setSearch={setSearch}
            headerTitle={headerTitle}
            items={items}
            title={`لیست اشخاص جدید ${items.length}`}
          />
          <Table
            className="mt-3"
            setSearch={setSearch}
            headerTitle={justNumberHeaderTitle}
            items={justNumber}
            title={`لیست فقط ثبت نامی ها ${justNumber.length}`}
          />
          <ChangeResponsibleFirstFileModal
            show={show.details}
            handleClose={() => setShow({ ...show, details: false })}
            idActivity={idActivity}
          />
          <DeleteUserModal
            show={show.delete}
            handleClose={() => setShow({ ...show, delete: false })}
            activityId={idActivity}
          />
        </FirstFilesWrapper>
      )}
    </>
  );
};
